<div *ngIf='data' class='EmailPosition'>
  <p *ngIf='data.last_email_at; else noEmail'>Last
    email: {{ data.last_email_at | timezone: 'MM/DD/YYYY [at] HH:mm' : userTimezone }}</p>
  <ng-template #noEmail>
    <p>Last Email: No Email Sent</p>
  </ng-template>
  <p *ngIf='data.next_email_at; else noNext'>
    Next Email: {{ data.next_email_at | timezone: 'MM/DD/YYYY' : userTimezone }}
  </p>
  <ng-template #noNext>
    <ng-container *ngIf='contactStatus === "Active"; else notActive'>
      <p>Contact is scheduled for mailing at next service date</p>
    </ng-container>
    <ng-template #notActive>
      <p>Next Email: No Email Scheduled</p>
    </ng-template>
  </ng-template>
</div>
